import { repeatOptions, getTimeOptions } from "utils/reserveTime";
import moment from "moment";

const initialState = {
  description: "Meeting",
  categories: [],
  category: null,
  startTime: null,
  endTime: null,
  repeat: repeatOptions[0],
  startDate: null,
  endDate: null,
  calendar: null,
};

export const getInitialState = ({
  startDate, 
  startTime, 
  duration, 
  description, 
  calendarOptions
}) => {
  const timeOptions = getTimeOptions();
  const initialStartTime = timeOptions.find(({value}) => value === startTime);
  const initialEndTime = initialStartTime && 
    timeOptions.find(({value}) => value === initialStartTime.date.clone().add(duration, 'minutes').format("h:mm a"));
  return {
    ...initialState,
    ...(description && { description }),
    ...(calendarOptions.length === 1 && { calendar: calendarOptions[0] }),
    ...(startDate && { startDate: moment(startDate) }),
    ...(initialStartTime && { startTime: initialStartTime }),
    ...(initialEndTime && { endTime: initialEndTime })
  }
}

export const reducer = (state, action) => {
  switch (action.type) {
    case "SET_VALUE":
      return { 
        ...state,
        ...({[action.field]: action.value}),
      };
  }
}
